module.exports = __webpack_public_path__ + "static/img/tip2.491df7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tip2.png
// module id = H/2b
// module chunks = 0